// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const paras: PokeData = {
  "id": 46,
  "name": "paras",
  "height": 3,
  "weight": 54,
  "base_experience": 57,
  "types": [
    PokeType.BUG,
    PokeType.GRASS
  ],
  "api_moves": [
    "scratch",
    "absorb",
    "growth",
    "poison-powder",
    "stun-spore",
    "sleep-powder",
    "leech-life",
    "spore",
    "fury-swipes",
    "slash",
    "giga-drain",
    "fury-cutter",
    "aromatherapy",
    "x-scissor",
    "energy-ball",
    "venoshock",
    "rage-powder"
  ],
  "moves": [
    "scratch",
    "poison-powder",
    "stun-spore",
    "aromatherapy",
    "energy-ball",
    "leaf-tornado",
    "solar-beam",
    "frenzy-plant",
    "synthesis",
    "pin-missile",
    "bullet-seed",
    "power-whip",
    "infest"
  ],
  "evolution_chain": {
    "id": 19,
    "item": null,
    "species": [
      {
        "name": "paras",
        "order": 51,
        "types": [
          PokeType.BUG,
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "parasect",
        "order": 52,
        "types": [
          PokeType.BUG,
          PokeType.GRASS
        ],
        "evolves_from_species_id": 46,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 24,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 45,
    "speed": 25,
    "ability_power": 70
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
